import { DistanceUnit } from './shared/src/utils.js';

const toKm = (meters)=>meters / 1000
;
const toMiles = (meters)=>meters / 1609.344
;
/**
 * Given a value of a type like `SomeType | WithDistance<SomeType>`, check
 * whether the value is of type `SomeType` or of type `WithDistance<SomeType>`.
 */ const hasDistance = (value)=>'distance' in value && typeof value.distance === 'number'
;
/**
 * Format a DistanceInMeters to a string representation in the given DistanceUnit.
 */ const formatDistance = (distance, distanceUnit, options)=>{
    if (typeof distance !== 'number' || distance === Infinity) {
        return '';
    }
    const separator = (options === null || options === void 0 ? void 0 : options.separator) || '';
    // number type check is needed in order to also allow 0 as precision value
    const hasPrecision = typeof (options === null || options === void 0 ? void 0 : options.precision) === 'number';
    /**
   * toFixed returned value conversion to number is needed in order to return
   * integer value when the result is integer, example: return 1km instead of 1.0km
   */ switch(distanceUnit){
        case DistanceUnit.km:
            return `${Number(toKm(distance).toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 1))}${separator}km`;
        case DistanceUnit.mile:
            return `${Number(toMiles(distance).toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 1))}${separator}mi`;
        case DistanceUnit.meter:
            return `${Number(distance.toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 0))}${separator}m`;
        default:
            console.warn(`Unknown distance unit ${distanceUnit}`);
            return distance.toFixed(hasPrecision ? options === null || options === void 0 ? void 0 : options.precision : 0);
    }
};

export { formatDistance, hasDistance, toKm, toMiles };
//# sourceMappingURL=format-distance.js.map
